import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { getHomeUrl } from '../../helpers/url/urlHelpers';
import IAppFrameViewModel from '../../interfaces/umbracoNodes/appFrameViewModel';
import { ContentContainerCard } from '../base/contentContainer/contentContainer';
import { Column, Columns } from '../base/grid';
import IconLink from '../base/iconLink';
import ChatBubble from '../chatBubble';
import * as StyledFooter from './footer.styles';

const Footer: FC = () => {
	const { appFrame }: { appFrame: IAppFrameViewModel } = useSelector(
		(state: { pageReducer: { appFrame: IAppFrameViewModel } }) => state.pageReducer
	);

	return (
		<StyledFooter.FooterContainer>
			<ChatBubble />
			<StyledFooter.PageContainerStyled>
				<StyledFooter.BackgroundWrapper>
					<ContentContainerCard>
						<Columns>
							<Column desktopSmall={1 / 4} marginBottom={56}>
								<Columns>
									<Column mobile={1 / 2} desktopSmall={1} marginBottom={0}>
										<IconLink
											href={getHomeUrl()}
											icon={appFrame.Values.FooterLogoIcon}
											preserveIconDimensions
										/>
									</Column>
									<Column mobile={1 / 2} desktopSmall={1} marginBottom={0}>
										<StyledFooter.GeneralInfo>
											<StyledFooter.BaseInfoWrapper>
												<StyledFooter.InfoTitle>
													{appFrame.Values.OrganisationName}
												</StyledFooter.InfoTitle>
												<StyledFooter.Info>{appFrame.Values.OrganisationSsn}</StyledFooter.Info>
											</StyledFooter.BaseInfoWrapper>
											<StyledFooter.InfoWrapper>
												<StyledFooter.Info>
													{appFrame.Values.OrganisationAddress}
												</StyledFooter.Info>
												<StyledFooter.Info>
													{appFrame.Values.OrganisationLocation}
												</StyledFooter.Info>
											</StyledFooter.InfoWrapper>
											<StyledFooter.InfoWrapper>
												<StyledFooter.Info>
													<StyledFooter.Email
														href={`mailto:${appFrame.Values.OrganisationEmail}`}>
														{appFrame.Values.OrganisationEmail}
													</StyledFooter.Email>
												</StyledFooter.Info>
											</StyledFooter.InfoWrapper>
										</StyledFooter.GeneralInfo>
									</Column>
								</Columns>
							</Column>
							<Column desktopSmall={3 / 4} marginBottom={0}>
								<Columns>
									{appFrame.Values.FooterLinkCollection.map((columnWithTitle, idx) => {
										const columnsLength = columnWithTitle.Values.Columns.length;
										return (
											<Column
												key={idx}
												mobile={(6 * columnsLength > 12 ? 12 : 6 * columnsLength) / 12}
												desktopSmall={(4 * columnsLength) / 12}
												marginBottom={40}>
												<StyledFooter.LinkTitle>
													{columnWithTitle.Values.Title}
												</StyledFooter.LinkTitle>
												<Columns>
													{columnWithTitle.Values.Columns.map((column, colIdx) => (
														<Column
															key={colIdx}
															mobile={(6 * columnsLength >= 12 ? 6 : 12) / 12}
															desktopSmall={12 / columnsLength / 12}
															marginBottom={16}>
															{column.Values.Links.map((link, linIdx) => (
																<StyledFooter.LinkWrapper key={linIdx}>
																	<StyledFooter.Link
																		href={link.Url}
																		title={link.Name}
																	/>
																</StyledFooter.LinkWrapper>
															))}
															{column.Values.SocialIcons &&
																column.Values.SocialIcons.length > 0 && (
																	<StyledFooter.SocialLinks>
																		{column.Values.SocialIcons.map(
																			(socialIcon, socIdx) => (
																				<StyledFooter.SocialLink
																					key={socIdx}
																					href={socialIcon.Values.Button.Url}
																					title={
																						socialIcon.Values.Button.Name
																					}
																					icon={socialIcon.Values.Icon}
																					target="_blank"
																				/>
																			)
																		)}
																	</StyledFooter.SocialLinks>
																)}
														</Column>
													))}
												</Columns>
											</Column>
										);
									})}
								</Columns>
							</Column>
						</Columns>
					</ContentContainerCard>
				</StyledFooter.BackgroundWrapper>
				<StyledFooter.LocaleCertificationWrapper>
					<StyledFooter.Certifications>
						{appFrame.Values.FooterCertifications?.map((certification, idx) => (
							<StyledFooter.CertificationLink
								key={idx}
								href={certification.Values.Button.Url}
								title={certification.Values.Button.Name}
								icon={certification.Values.Icon}
							/>
						))}
					</StyledFooter.Certifications>
					{/* <StyledFooter.LocaleWrapper>
						<Globe />
						<StyledFooter.LanguageSwitch />
					</StyledFooter.LocaleWrapper> */}
				</StyledFooter.LocaleCertificationWrapper>
			</StyledFooter.PageContainerStyled>
		</StyledFooter.FooterContainer>
	);
};

export default Footer;
